"use strict";

import { insightConstants } from "../_constants";

export const INITIAL_INSIGHT_STATE = {
    liveboardList: [],
    participantJobRolesAndCount: [],
    dealersSummaryStats: [],

    sherbotAIInstructionResult: null,
    sherbotAIInstructionLoading: false,
    sherbotAIInstructionError: null,

    sherbotAIInstructionUpdateResult: null,
    sherbotAIInstructionUpdateLoading: null,
    sherbotAIInstructionUpdateError: null,
};

export function insights(state = INITIAL_INSIGHT_STATE, action) {
    switch (action.type) {
        // Sherbot AI get instructions
        case insightConstants.SHERBOT_GET_AI_INSTRUCTION_REQUEST:
            return {
                ...state,
                sherbotAIInstructionLoading: true,
                sherbotAIInstructionError: null,
            };
        case insightConstants.SHERBOT_GET_AI_INSTRUCTION_COMPLETED:
            return {
                ...state,
                sherbotAIInstructionResult:
                    action.payload?.data || action.payload,
                sherbotAIInstructionLoading: false,
                sherbotAIInstructionError: null,
            };
        case insightConstants.SHERBOT_GET_AI_INSTRUCTION_ERROR:
            return {
                ...state,
                sherbotAIInstructionLoading: false,
                sherbotAIInstructionError: action.payload?.error,
            };

        // Sherbot AI update instructions
        case insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_REQUEST:
            return {
                ...state,
                sherbotAIInstructionUpdateLoading: true,
                sherbotAIInstructionUpdateError: null,
            };
        case insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_COMPLETED:
            return {
                ...state,
                sherbotAIInstructionUpdateResult:
                    action.payload?.data || action.payload,
                sherbotAIInstructionUpdateLoading: false,
                sherbotAIInstructionUpdateError: null,
            };
        case insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_ERROR:
            return {
                ...state,
                sherbotAIInstructionUpdateLoading: false,
                sherbotAIInstructionUpdateError: action.payload?.error,
            };

        // AI insight Dashboard
        case insightConstants.INSIGHT_GET_LIST_OF_LIVEBOARD_COMPLETE:
            return {
                ...state,
                liveboardList: [...action.payload.data],
            };

        case insightConstants.INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_COMPLETED:
            return {
                ...state,
                participantJobRolesAndCount: [...action.payload.data],
            };

        case insightConstants.INSIGHT_GET_DEALERS_SUMMARY_COMPLETED:
            return {
                ...state,
                dealersSummaryStats: [...action.payload.data],
            };

        default:
            return state;
    }
}
